<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-16">
                <div class="card-title mb-0">
                    <h3>Properties</h3>
                    <ms-property-list [currentPropertyListViewLocation]="profilePageViewLocation"
                        [activeMemberId]="member()?.memberId"></ms-property-list>
                </div>
            </div>
        </div>
    </div>
</div>

<ms-add-properties-to-member
  *ifHasPermission="{ requiredPermissions: [PropertyPermission.Update] }"
  [member]="member()"
  (memberAddedToProperty)="onMemberAddedToProperty()">
</ms-add-properties-to-member>